import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { UpOutlined, DownOutlined } from '@ant-design/icons';
import { Card, CardHeader, Collapse } from 'reactstrap';

const column1 = [
  {
    Header: 'Drawing No.',
    accessor: 'docNum',
  },
  {
    Header: 'CAGE',
    accessor: 'cage',
  },
  {
    Header: 'Type',
    accessor: 'docType',
  },
  // {
  //   Header: "Doc Data"
  // }
  {
    Header: 'Doc Date',
    accessor: 'docDate',
  },
  {
    Header: 'Data Type',
    accessor: 'docDataCd',
  },
  {
    Header: 'Rev',
    accessor: 'docRev',
  },

  {
    Header: 'Rev Date',
    accessor: 'revDate',
  },

  {
    Header: 'Ty No.',
    accessor: 'typeNum',
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);

  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Drawing Details {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/DrawingDetails.jsx